"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Faq = _interopRequireDefault(require("../Faq"));
var _HappyFox = _interopRequireDefault(require("../HappyFox"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HelpCenter = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function HelpCenter(props) {
    var _this;
    _classCallCheck(this, HelpCenter);
    _this = _callSuper(this, HelpCenter, [props]);
    _defineProperty(_this, "state", {
      toggled: false
    });
    _defineProperty(_this, "toggleContact", function () {
      _this.setState({
        toggled: !_this.state.toggled
      });
    });
    _defineProperty(_this, "initializeHappyFox", function () {
      var settings = window.cccisd.appDefs.helpCenters.list.find(function (item) {
        return item.id === _this.props.helpCenter;
      });
      if (window.HFCHAT_CONFIG) {
        return;
      }
      if (!settings.liveChat.embedToken) {
        return;
      }
      window.HFCHAT_CONFIG = {
        EMBED_TOKEN: settings.liveChat.embedToken,
        ASSETS_URL: 'https://widget.happyfoxchat.com/v2/visitor'
      };
      var script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('async', true);
      script.src = window.HFCHAT_CONFIG.ASSETS_URL + '/js/widget-loader.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      window.HFCHAT_CONFIG.options = {
        showBadgeOnLoad: false,
        // Will hide badge only on load
        showBadge: false // always hide badge
      };
      window.HFCHAT_CONFIG.onload = function () {
        window.cccisd.HappyFoxChat = this;
        window.cccisd.HappyFoxChat.on('collapse:chatbox', function () {
          window.cccisd.HappyFoxChat.hideWidget();
        });
      };
    });
    _this.toggleContact = _this.toggleContact.bind(_this);
    return _this;
  }
  _inherits(HelpCenter, _React$Component);
  return _createClass(HelpCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeHappyFox();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var settings = window.cccisd.appDefs.helpCenters.list.find(function (item) {
        return item.id === _this2.props.helpCenter;
      });
      if (typeof settings === 'undefined') {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("i", null, "Error: help center \"", this.props.helpCenter, "\" not found")));
      }
      var toggled = this.state.toggled;
      var contact = settings.contact;
      var startsOpen = false;
      var showContactText = 'I still need help...';
      if (typeof contact.startsOpen !== 'undefined') {
        startsOpen = contact.startsOpen;
      }
      if (typeof contact.showContactText !== 'undefined') {
        showContactText = contact.showContactText;
      }
      var faq = '';
      var contactBlock = '';
      var contactInfo = '';
      var chat = '';
      if (settings.showFaq) {
        faq = /*#__PURE__*/_react["default"].createElement(_Faq["default"], settings.faq);
      }
      if (settings.showChat) {
        chat = /*#__PURE__*/_react["default"].createElement(_HappyFox["default"], settings.liveChat);
      }
      if (contact.email || contact.phone) {
        contactInfo = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].contact
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: contact.contactHeader
        }), /*#__PURE__*/_react["default"].createElement("ul", null, contact.email && /*#__PURE__*/_react["default"].createElement("li", null, "Email: ", /*#__PURE__*/_react["default"].createElement("a", {
          href: 'mailto:' + contact.email
        }, contact.email)), contact.phone && /*#__PURE__*/_react["default"].createElement("li", null, "Phone: ", contact.phone)));
      }
      if (chat || contactInfo) {
        if (startsOpen || toggled) {
          contactBlock = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contactWrapper
          }, contactInfo, chat);
        } else {
          contactBlock = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contactWrapper
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contactToggle
          }, /*#__PURE__*/_react["default"].createElement("a", {
            onClick: this.toggleContact
          }, showContactText)));
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _style["default"].helpCenter
      }, faq, faq && contactBlock && /*#__PURE__*/_react["default"].createElement("hr", null), contactBlock);
    }
  }]);
}(_react["default"].Component);
_defineProperty(HelpCenter, "propTypes", {
  helpCenter: _propTypes["default"].string
});
_defineProperty(HelpCenter, "defaultProps", {
  helpCenter: 'default'
});